import useIsEmea from "@dana/Common/Hooks/useIsEmea";
import GlobalSearchByVehicleComponant from "@dana/Components/GlobalSearchByVehicle/GlobalSearchByVehicleComponant";
import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import DanaApplicationState from "@dana/Store/DanaApplicationState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import ManagedAccordionSection from "@insite/mobius/AccordionSection/ManagedAccordionSection";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    categoryId = "categoryId",
    categoryName = "categoryName",
    addIsAccordian = "addIsAccordian",
    initialExpanded = "initialExpanded"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.categoryId]: string;
        [fields.categoryName]: string;
        [fields.addIsAccordian]: boolean;
        [fields.initialExpanded]: boolean;
    };
}

const mapStateToProps = (state: DanaApplicationState) => {
    const searchVehicleFiltersSate = state.searchVehicleFilter || {};
    const isEmea = useIsEmea(state);
    return {
        searchVehicleFiltersSate,
        isEmea
    };
}


type Props = OwnProps & HasHistory & ReturnType<typeof mapStateToProps>;


export interface GlobalSearchByVehicleStyles {
    mainContainer?: InjectableCss;
    accordionSectionHambuger?: AccordionSectionPresentationProps;
    searchByVehicleText?: TypographyPresentationProps;
}

export const globalSearchByVehicleStyles: GlobalSearchByVehicleStyles = {
    mainContainer: {
        css: css`
            background: ${themeColors.primary.white};
            padding: 24px;

            ::before {
                    background: ${themeColors.secondary.danaDarkBlue};
                    display: block;
                    position: absolute;
                    content: "";
                    height: 100px;
                    width: 100px;
                    z-index: -1;
                    top: -8px;
                    left: -8px;
            }
        `
    },
    accordionSectionHambuger: {
        headerProps: {
            css: css`
                    button {
                        display: flex;
                        padding: 8px 16px;
                        justify-content: space-between;
                        background: ${themeColors.primary.white};
                        align-items: center;
                        align-self: stretch;
    
                        :hover {
                            background: ${themeColors.primary.white};
                        }
                    }
                    button[aria-expanded="true"] {
                        display: flex;
                        padding: 8px 16px;
                        justify-content: space-between;
                        background: ${themeColors.primary.white};
                        align-items: center;
                        align-self: stretch;
                    }
                    button:focus {
                        display: flex;
                        padding: 8px 16px;
                        justify-content: space-between;
                        background: white;
                        align-items: center;
                        align-self: stretch;
                        outline-offset: -1px;
                    }
                `,
        },
        panelProps: {
            css: css`
                    padding: 0px;
                    border: 0;
    
                    > div > div:nth-child(2) {
                        h3 {
                            display: none;
                        }
                    }
                `,
        },
    },
    searchByVehicleText: {
        variant: "h3",

        css: css`
                margin-bottom: 24px;
            `
    },
};

const styles = globalSearchByVehicleStyles;

const GlobalSearchByVehicle: React.FC<Props> = ({ fields, searchVehicleFiltersSate ,isEmea}) => {
    if(isEmea){
        return <></>;
    }
    const [categoryId, setCategoryId] = useState(fields.categoryId[0] || "");

    const [isAccordian, setIsAccordian] = useState(false);
    const [initialExpanded, setInitialExpanded] = useState(false);
    useEffect(() => {
        setCategoryId(fields.categoryId[0]);
       
        setIsAccordian(fields.addIsAccordian);
        setInitialExpanded(fields.initialExpanded);
    }, [fields]);

    return (
        <LoadingOverlay loading={searchVehicleFiltersSate.isFilterLoading}>
            <StyledWrapper {...globalSearchByVehicleStyles.mainContainer} className="global-search-main-container">
                {isAccordian ? (
                    <ManagedAccordionSection
                        title={<Typography className="text-body-md">{translate("Search By Vehicle")}</Typography>}
                        initialExpanded={initialExpanded}
                        {...styles.accordionSectionHambuger}
                    >
                        <GlobalSearchByVehicleComponant></GlobalSearchByVehicleComponant>
                    </ManagedAccordionSection>) :
                    <>
                        <Typography {...globalSearchByVehicleStyles.searchByVehicleText}>
                            {translate("Search By Vehicle")}
                        </Typography>
                        <GlobalSearchByVehicleComponant></GlobalSearchByVehicleComponant>
                    </>
                }
            </StyledWrapper>
        </LoadingOverlay>
    );
};


const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(GlobalSearchByVehicle)),
    definition: {

        group: "Common",
        displayName: "Global Vehicle Search",
        fieldDefinitions: [
            {
                name: fields.addIsAccordian,
                displayName: "Display As Accordian",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.initialExpanded,
                displayName: "Is Accordion Initially Open",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                isVisible: item => item.fields.addIsAccordian === true
            },
        ]
    }
};
export default widgetModule;


